export const selectOpenModals = (state) => state.ui.openModals;
